import { SchoolUserRole } from '@novaheal/types';
import { useUser } from 'utils/auth';

/**
 * Hook to check if the current user is a teacher or admin.
 * A user is considered eligible if:
 * - Their educationStatus is 'TEACH' or 'GUIDE', OR
 * - They have a school role of 'TEACHER' in their schoolRoles array, OR
 * - They have a school role of 'ADMIN' in their schoolRoles array
 */
export const useIsTeacherOrAdmin = (): boolean => {
  const { data: user } = useUser();

  if (!user) {
    return false;
  }

  const isTeacher = user.educationStatus === 'TEACH';
  const isGuide = user.educationStatus === 'GUIDE';

  const { schoolRole: userRole } = user ?? {};

  const isB2BTeacher = userRole?.roles?.includes(SchoolUserRole.TEACHER) ?? false;
  const isB2BGuide = userRole?.roles?.includes(SchoolUserRole.GUIDE) ?? false;
  const isB2BAdmin = userRole?.roles?.includes(SchoolUserRole.ADMIN) ?? false;

  return isTeacher || isB2BTeacher || isGuide || isB2BAdmin || isB2BGuide;
};
